import { jsx } from 'react/jsx-runtime';

const SvgNavVersions = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M6 2h12v2H6V2ZM4 6h16v2H4V6ZM3 10v8h2v-6h14v8H3v2h18V10H3Z" }) }));

export { SvgNavVersions as default };
//# sourceMappingURL=NavVersions.es.js.map
